import React from 'react';
import { Handle, Position } from 'reactflow';

export default React.forwardRef<HTMLDivElement>((_, ref) => (
	<Handle
		ref={ref}
		type="target"
		data-testid="node-target-drop"
		className="node-target-drop"
		position={Position.Left}
		style={{
			zIndex: -1,
			height: '100%',
			top: 0,
			transform: 'none',
			left: 0,
			backgroundColor: 'transparent',
			borderRadius: 0,
			border: 'none',
			width: '100%',
			display: 'flex',
			justifyContent: 'flex-start',
			alignItems: 'center'
		}}
	/>
));
